module.exports = __webpack_public_path__ + "assets/mp3/audio2/audio_2_1a.mp3";